export default __webpack_public_path__ + "static/social-estados-diff-c2778136955c9fe6a842b82246f4aa0d.png";